import get from "lodash/get"
import { observable, computed, action } from "mobx"
import { authStore } from "../stores"
import { firebase } from "../constants"

class StorefrontStore {
  @observable name = ""
  @observable logo = ""
  @observable description = ""
  @observable previewMessage = ""
  @observable acceptsDesignCopyright = false

  @computed
  get unsavedChanges() {
    return (
      this.name !== get(authStore.store, "name") ||
      this.logo !== get(authStore.store, "config.logo") ||
      this.description !== get(authStore.store, "config.description") ||
      this.previewMessage !== get(authStore.store, "config.previewMessage")
    )
  }

  @action.bound
  changeName(name) {
    this.name = name
  }

  @action.bound
  changeDescription(description) {
    this.description = description
  }

  @action.bound
  changePreviewMessage(message) {
    this.previewMessage = message
  }

  @action.bound
  changeLogo(logo) {
    this.logo = logo
  }

  @action.bound
  acceptDesignCopyright() {
    this.acceptsDesignCopyright = true
    this.save()
  }

  @action.bound
  save() {
    const storeRef = firebase
      .database()
      .ref("stores")
      .child(authStore.userStoreId)

    storeRef.child("name").set(this.name)

    storeRef.child("config").set({
      logo: this.logo,
      description: this.description,
      previewMessage: this.previewMessage,
      acceptsDesignCopyright: this.acceptsDesignCopyright,
    })
  }

  @action.bound
  reset() {
    this.name = get(authStore.store, "name", "")
    this.logo = authStore.userStoreLogo
    this.description = get(authStore.store, "config.description", "")
    this.previewMessage = get(authStore.store, "config.previewMessage", "")
    this.acceptsDesignCopyright = get(
      authStore.store,
      "config.acceptsDesignCopyright",
      false
    )
  }
}

export default new StorefrontStore()



// WEBPACK FOOTER //
// ./src/storefront/store.js